import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3491aa91"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  src: "/images/icon-layers.svg",
  class: "multi-images"
}
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_lazy = _resolveDirective("lazy")!

  return _withDirectives((_openBlock(), _createBlock(_component_router_link, {
    "data-src": 'url(/media/' + _ctx.item.thumb + ')',
    to: '/project/' + _ctx.item.id,
    class: "item"
  }, {
    default: _withCtx(() => [
      (_ctx.item.images.length)
        ? (_openBlock(), _createElementBlock("img", _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        innerHTML: _ctx.item.title,
        class: _normalizeClass(['title', {'mobile-title': _ctx.store.showMobile}])
      }, null, 10, _hoisted_2)
    ]),
    _: 1
  }, 8, ["data-src", "to"])), [
    [_directive_lazy]
  ])
}